import React, { useEffect, useState } from 'react';
import {
  Datagrid,
  FunctionField,
  List,
  TextField,
} from 'react-admin';
import Select, { components } from 'react-select';
import { getFormattedDate_T } from '../utils';
import { customDataProvider } from '../data-provider';
import { promocodeStatusOptions } from '../utils/constants';

const initialFilterState = {
  search: '',
  // dateLower: '',
  // dateUpper: '',
  status:'',
  locations: [],
};

const PromoFilter = ({ onSearch }) => {
  const [workLocations, setWorkLocations] = useState([]);
  const [localFilters, setLocalFilters] = useState(initialFilterState);

  useEffect(() => {
    customDataProvider.getList('userlocations').then(data => {
      setWorkLocations(data.data);
    });

    // Load saved filters on mount
    const savedFilters = localStorage.getItem('promoFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      setLocalFilters(filters);
      onSearch(filters);
    }
  }, []);

  const handleFilterChange = (field, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleLocationChange = selectedOptions => {
    const selectedLocations = selectedOptions
      ? selectedOptions.map(option => option.value)
      : [];
    handleFilterChange('locations', selectedLocations);
  };

  const handleApplyFilters = () => {
    const validFilters = Object.fromEntries(
      Object.entries(localFilters).filter(([_, value]) =>
        Array.isArray(value) ? value.length > 0 : value?.trim?.(),
      ),
    );

    if (Object.keys(validFilters).length > 0) {
      localStorage.setItem('promoFilters', JSON.stringify(validFilters));
    } else {
      localStorage.removeItem('promoFilters');
    }

    onSearch(validFilters);
  };

  const handleClearFilters = () => {
    localStorage.removeItem('promoFilters');
    setLocalFilters(initialFilterState);
    onSearch({});
  };

  const locationOptions = workLocations.map(loc => ({
    value: loc.location_id,
    label: loc.location.name,
  }));

  const CustomMultiValue = props => {
    const { data, index } = props;
    const selectedCount = localFilters.locations.length;
    if (selectedCount > 2 && index >= 2) return null;

    return (
      <>
        <components.MultiValue {...props}>
          <components.MultiValueRemove {...props} />
        </components.MultiValue>
        {selectedCount > 2 && index === 1 ? ` +${selectedCount - 2}` : ''}
      </>
    );
  };

  return (
    <div className="promoFilterMain">
      <div className="searchWrapper promoFilters">
        <div className="filter-item">
          <label>Search</label>
          <input
            type="text"
            placeholder="Promo Code"
            value={localFilters.search || ''}
            onChange={e => handleFilterChange('search', e.target.value)}
          />
        </div>
        {/* <div className="filter-item">
          <label>Start Date</label>
          <input
            type="date"
            value={localFilters.dateLower || ''}
            onChange={e => handleFilterChange('dateLower', e.target.value)}
          />
        </div>
        <div className="filter-item">
          <label>End Date</label>
          <input
            type="date"
            value={localFilters.dateUpper || ''}
            onChange={e => handleFilterChange('dateUpper', e.target.value)}
          />
        </div> */}
           <div className="filter-item">
          <label>Status</label>
          <Select
            isMulti={false}
            name="status"
            options={promocodeStatusOptions}
            value={promocodeStatusOptions.find(option => option.value === localFilters.status) || null}
            onChange={option => handleFilterChange('status', option ? option.value : '')}
            placeholder="Select Status"
            classNamePrefix="select"
          />
        </div>
        <div className="filter-item">
          <label>Shops</label>
          <Select
            isMulti
            name="locations"
            options={locationOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            value={locationOptions.filter(option =>
              localFilters?.locations?.includes(option?.value),
            )}
            onChange={handleLocationChange}
            placeholder="Select locations..."
            noOptionsMessage={() => 'No locations found'}
            components={{
              MultiValue: CustomMultiValue,
            }}
            styles={{
              control: base => ({
                ...base,
                minHeight: '38px',
                border: '1px solid #ccc',
              }),
              valueContainer: base => ({
                ...base,
                padding: '2px 8px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }),
              multiValue: base => ({
                ...base,
                backgroundColor: '#f0f0f0',
              }),
              multiValueLabel: base => ({
                ...base,
                fontSize: '14px',
              }),
            }}
          />
        </div>
        <div className="filter-buttons">
          <button
            type="button"
            onClick={handleApplyFilters}
            className="apply-filters-btn"
          >
            Apply
          </button>
          <button
            type="button"
            onClick={handleClearFilters}
            className="clear-filters-btn"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

const onRowClick = (id, basePath, record) => {
  const role = localStorage.getItem('role');
  if (role === 'admin' || role === 'gss') {
    return 'edit';
  } else if (
    role === 'front_desk' ||
    role === 'shop_manager' ||
    role === 'operating-partner'
  ) {
    return `/promo/details/${id}`;
  } else {
    return 'show';
  }
};

const NoMatchingResults = () => (
  <div className="promo-no-match-found">
    <div className="promo-text">
      There are no promos matching your criteria.
    </div>
  </div>
);

const EmptyList = data => {
  if (Object.keys(data.filter).length > 0) {
    return <NoMatchingResults />;
  } else return <div></div>;
};

const PromoListView = ({ filterValues, data = [] }) => {
  return (
    <Datagrid rowClick={onRowClick}>
      <TextField source="code" label="Promo Code" />
      <FunctionField
        label="Start Date"
        render={record => getFormattedDate_T(record.promo_start_date)}
      />
      <FunctionField
        label="End Date"
        render={record => getFormattedDate_T(record.promo_end_date)}
      />
      <FunctionField
        label="Capacity"
        render={record => record.capacity}
      />
      <FunctionField
        label="Uses"
        render={record => record.uses}
      />
    </Datagrid>
  );
};

export const PromoList = props => {
  const [filterValues, setFilterValues] = useState({});

  const handleSearch = searchFilters => {
    setFilterValues(searchFilters);
  };

  return (
    <div>
      <PromoFilter onSearch={handleSearch} />
      <List
        {...props}
        filter={filterValues}
        perPage={25}
        bulkActionButtons={false}
        className="main-table"
        exporter={false}
        disableSyncWithLocation={true}
        empty={<EmptyList />}
      >
        <PromoListView filterValues={filterValues} />
      </List>
    </div>
  );
};
